import { useContext } from 'react';
import { SessionContext } from './session.context';

export function useSessionId(): string {
  const context = useContext(SessionContext);

  if (!context) {
    throw new Error('useSessionId must be used within a SessionProvider');
  }

  return context.sessionId;
}
